var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPcGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 278,
    height: 278,
    viewBox: "0 0 278 278",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f2f2f2;}.b{fill:#818386;}.c{fill:#444547;}.d{fill:#aeb0af;}.e{fill:#fff;}.f{fill:#696e6f;}.g{fill:#464749;}.h{fill:#6d6f72;}.i{fill:#aeb0b3;}.j{fill:#354246;opacity:0.604;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-106 -235)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 139,
    cy: 139,
    r: 139,
    transform: "translate(106 235)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(166.164 274.463)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.62 89.144)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M696.143,366.618l-2.1,1.161L645.95,321.6c-.168,1.045-.827,3.533.7,4.906l47.181,44.922a2.972,2.972,0,0,0,2.174.726Z",
    transform: "translate(-645.664 -262.228)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M800.219,307.125,683.807,371.377l-.132,5.333a2.766,2.766,0,0,0,1.5-.317L799.43,312.528C801.217,311.788,801.118,307.765,800.219,307.125Z",
    transform: "translate(-633.692 -266.785)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M811.695,316.355a1.188,1.188,0,0,1-.179,2.171L697.263,382.389a3,3,0,0,1-3.318-.416L646.42,336.729a1.353,1.353,0,0,1,.256-2.339l111.4-57.627a3.587,3.587,0,0,1,3.393.247Z",
    transform: "translate(-645.601 -276.448)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M806.64,316.078c.782.563.646,1.445-.31,1.978L697.152,378.887a2.759,2.759,0,0,1-3.044-.275l-44.73-42.434a1.233,1.233,0,0,1,.372-2.114L756.437,278.67a3.261,3.261,0,0,1,3.106.138Z",
    transform: "translate(-644.636 -275.85)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.791 7.37)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M666.173,326.536l-5.209,2.771-4.43-4.127,5.192-2.736Z",
    transform: "translate(-654.031 -269.331)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M671.312,323.791l-5.208,2.772-4.452-4.084,5.193-2.735Z",
    transform: "translate(-652.419 -270.181)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M664.238,321.1l-7.952,4.185-1.655-1.541,7.943-4.165Z",
    transform: "translate(-654.63 -270.232)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M671.327,317.37l-7.954,4.182-1.664-1.515,7.943-4.163Z",
    transform: "translate(-652.401 -271.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M678.416,313.637l-7.954,4.184-1.676-1.492,7.944-4.166Z",
    transform: "translate(-650.172 -272.569)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M685.5,309.9l-7.951,4.184-1.686-1.469,7.943-4.164Z",
    transform: "translate(-647.942 -273.737)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M692.593,306.17l-7.951,4.182-1.7-1.446,7.944-4.163Z",
    transform: "translate(-645.713 -274.906)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M699.682,302.437l-7.951,4.181-1.707-1.423,7.941-4.162Z",
    transform: "translate(-643.483 -276.074)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M706.772,298.7l-7.951,4.186-1.719-1.4,7.943-4.164Z",
    transform: "translate(-641.254 -277.243)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M713.862,294.967l-7.954,4.185-1.728-1.375,7.945-4.164Z",
    transform: "translate(-639.024 -278.412)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M720.952,291.235,713,295.42l-1.741-1.355L719.2,289.9Z",
    transform: "translate(-636.795 -279.581)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M728.038,287.5l-7.952,4.182-1.75-1.328,7.942-4.164Z",
    transform: "translate(-634.565 -280.749)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M736.209,283.333l-9.032,4.754-1.762-1.306,9.023-4.728Z",
    transform: "translate(-632.336 -282.053)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M676.45,321.05l-5.208,2.772-4.474-4.039,5.193-2.734Z",
    transform: "translate(-650.807 -271.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M681.59,318.3l-5.21,2.775-4.494-3.991,5.194-2.736Z",
    transform: "translate(-649.195 -271.88)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M686.728,315.562l-5.207,2.772-4.515-3.945,5.192-2.737Z",
    transform: "translate(-647.583 -272.729)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M691.866,312.821l-5.209,2.771-4.534-3.9,5.191-2.737Z",
    transform: "translate(-645.971 -273.579)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M697,310.08l-5.2,2.767-4.556-3.852,5.189-2.735Z",
    transform: "translate(-644.359 -274.428)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M702.142,307.337l-5.207,2.769-4.578-3.808,5.191-2.735Z",
    transform: "translate(-642.748 -275.277)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M707.28,304.593l-5.205,2.771-4.6-3.764,5.19-2.734Z",
    transform: "translate(-641.135 -276.127)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M712.417,301.851l-5.205,2.772-4.62-3.719,5.192-2.736Z",
    transform: "translate(-639.524 -276.977)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M670.685,330.684l-5.23,2.817-4.43-4.125,5.216-2.784Z",
    transform: "translate(-652.616 -268.024)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M675.845,327.892l-5.228,2.819-4.451-4.078,5.214-2.784Z",
    transform: "translate(-650.997 -268.888)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M681,325.1l-5.229,2.819L671.3,323.89l5.214-2.785Z",
    transform: "translate(-649.379 -269.753)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M686.165,322.315l-5.23,2.82-4.491-3.989,5.214-2.784Z",
    transform: "translate(-647.76 -270.616)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M691.325,319.527l-5.229,2.817-4.512-3.944,5.213-2.784Z",
    transform: "translate(-646.141 -271.481)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M696.483,316.737l-5.228,2.819-4.534-3.9,5.213-2.784Z",
    transform: "translate(-644.523 -272.345)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M701.641,313.952l-5.226,2.815-4.554-3.852,5.211-2.781Z",
    transform: "translate(-642.904 -273.208)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M706.8,311.161l-5.228,2.816L697,310.17l5.212-2.78Z",
    transform: "translate(-641.286 -274.072)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M711.961,308.372l-5.226,2.817-4.6-3.761,5.209-2.783Z",
    transform: "translate(-639.667 -274.937)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M717.121,305.585l-5.23,2.819-4.615-3.719,5.212-2.783Z",
    transform: "translate(-638.049 -275.801)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M675.2,334.833l-5.25,2.865-4.432-4.126,5.237-2.831Z",
    transform: "translate(-651.201 -266.718)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M680.383,332l-5.252,2.865-4.452-4.08,5.236-2.832Z",
    transform: "translate(-649.576 -267.596)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M685.562,329.165l-5.252,2.862-4.471-4.035,5.235-2.832Z",
    transform: "translate(-647.95 -268.475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M690.745,326.328l-5.254,2.864L681,325.2l5.237-2.831Z",
    transform: "translate(-646.325 -269.354)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M695.925,323.492l-5.25,2.865-4.515-3.946,5.234-2.829Z",
    transform: "translate(-644.7 -270.232)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M701.105,320.659l-5.251,2.864-4.536-3.9,5.236-2.83Z",
    transform: "translate(-643.075 -271.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M706.284,317.825l-5.249,2.862-4.555-3.854,5.232-2.828Z",
    transform: "translate(-641.449 -271.988)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M711.466,314.989l-5.25,2.864-4.576-3.809,5.234-2.83Z",
    transform: "translate(-639.824 -272.868)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M716.646,312.153l-5.248,2.862-4.6-3.764,5.232-2.826Z",
    transform: "translate(-638.199 -273.746)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M721.827,309.317l-5.25,2.868-4.618-3.72,5.235-2.828Z",
    transform: "translate(-636.574 -274.624)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M679.714,338.982l-5.273,2.911-4.43-4.127,5.257-2.875Z",
    transform: "translate(-649.786 -265.411)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M684.917,336.1l-5.272,2.911-4.452-4.081,5.256-2.875Z",
    transform: "translate(-648.154 -266.304)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M690.119,333.219l-5.273,2.913-4.471-4.035,5.255-2.878Z",
    transform: "translate(-646.522 -267.197)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M695.465,330.463l-5.275,2.915-4.636-4.118,5.258-2.878Z",
    transform: "translate(-644.891 -268.091)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M734.692,313.05l-39.443,21.783-4.514-3.944,39.323-21.52Z",
    transform: "translate(-643.259 -273.449)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M717.069,299.369l-5.21,2.772-4.636-3.676,5.191-2.735Z",
    transform: "translate(-638.066 -277.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M721.79,303.06l-5.229,2.819-4.636-3.675,5.213-2.784Z",
    transform: "translate(-636.585 -276.583)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M726.512,306.754l-5.25,2.865-4.636-3.678,5.235-2.829Z",
    transform: "translate(-635.104 -275.42)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M731.238,310.445l-5.274,2.914-4.636-3.678,5.256-2.875Z",
    transform: "translate(-633.623 -274.256)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M721.714,296.889l-5.207,2.771-4.656-3.637,5.191-2.735Z",
    transform: "translate(-636.608 -278.514)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M726.457,300.537l-5.23,2.819-4.654-3.633,5.214-2.784Z",
    transform: "translate(-635.121 -277.364)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M731.2,304.19l-5.251,2.865-4.656-3.635,5.234-2.83Z",
    transform: "translate(-633.634 -276.214)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M735.944,307.839l-5.273,2.911-4.658-3.634,5.258-2.875Z",
    transform: "translate(-632.148 -275.064)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M726.364,294.406l-5.208,2.772-4.675-3.594,5.193-2.735Z",
    transform: "translate(-635.15 -279.282)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M731.125,298.014l-5.23,2.819-4.675-3.59,5.216-2.785Z",
    transform: "translate(-633.657 -278.146)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M735.888,301.626l-5.252,2.865-4.674-3.6,5.235-2.83Z",
    transform: "translate(-632.164 -277.009)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M740.649,305.234l-5.274,2.913-4.674-3.594,5.255-2.878Z",
    transform: "translate(-630.671 -275.872)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M731.013,291.925,725.8,294.7l-4.694-3.554,5.193-2.735Z",
    transform: "translate(-633.692 -280.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M735.791,295.493l-5.23,2.819-4.692-3.551,5.214-2.785Z",
    transform: "translate(-632.193 -278.927)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M740.573,299.061l-5.25,2.862-4.694-3.552,5.235-2.829Z",
    transform: "translate(-630.694 -277.804)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M745.354,302.628l-5.273,2.914-4.693-3.556,5.258-2.875Z",
    transform: "translate(-629.195 -276.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M735.661,289.446l-5.21,2.772-4.713-3.513,5.195-2.737Z",
    transform: "translate(-632.234 -280.819)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M740.46,292.969l-5.232,2.82-4.711-3.511,5.216-2.783Z",
    transform: "translate(-630.729 -279.708)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M745.262,296.5l-5.253,2.866-4.713-3.512,5.237-2.829Z",
    transform: "translate(-629.224 -278.598)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M750.06,300.021l-5.274,2.912-4.712-3.511,5.256-2.879Z",
    transform: "translate(-627.719 -277.488)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M740.308,286.965l-5.209,2.771-4.732-3.471,5.193-2.736Z",
    transform: "translate(-630.776 -281.587)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M745.125,290.448l-5.23,2.819-4.73-3.47,5.215-2.784Z",
    transform: "translate(-629.265 -280.49)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M749.946,293.931l-5.253,2.868-4.73-3.471L745.2,290.5Z",
    transform: "translate(-627.754 -279.393)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M754.765,297.415l-5.273,2.912-4.731-3.472,5.257-2.875Z",
    transform: "translate(-626.243 -278.296)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M747.708,324.939c.214.153.176.394-.084.538l-29.751,16.576a.749.749,0,0,1-.83-.075l-12.19-11.564a.335.335,0,0,1,.1-.575l29.073-15.1a.889.889,0,0,1,.847.041Z",
    transform: "translate(-627.06 -264.414)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M642.911,271.087a4.27,4.27,0,0,1,2.208-3.394q57.169-29.445,114.338-58.883c1.22-.627,6.664.772,6.664,2.018L649.813,272.62Z",
    transform: "translate(-642.911 -208.655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M649.813,257.666l-6.9-1.533v77.84c0,1.308,2.881,4.9,6.9,3.131V257.666",
    transform: "translate(-642.911 -193.702)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M765.237,289.4a4.275,4.275,0,0,1-2.209,3.4q-57.169,29.441-114.338,58.881c-1.22.627-2.209.128-2.209-1.122q0-39.037,0-78.076a4.276,4.276,0,0,1,2.209-3.4q57.167-29.441,114.338-58.881c1.219-.627,2.209-.125,2.209,1.12Q765.237,250.365,765.237,289.4Z",
    transform: "translate(-641.787 -208.253)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M762.554,287.586a4.074,4.074,0,0,1-2.105,3.239q-55.108,28.381-110.217,56.758c-1.162.6-2.105.121-2.105-1.068q0-37.216,0-74.429a4.077,4.077,0,0,1,2.105-3.237q55.108-28.381,110.217-56.758c1.164-.6,2.105-.121,2.105,1.068Q762.552,250.374,762.554,287.586Z",
    transform: "translate(-641.269 -207.655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M733.655,272.956c-11.85,7.89-26.948,13.63-41.461,10.242-13.733-3.2-20.838-15.137-19.868-28.257a50.125,50.125,0,0,1,1.156-7.042q-11.626,5.984-23.251,11.973a4.077,4.077,0,0,0-2.105,3.237q0,37.212,0,74.429c0,1.189.943,1.666,2.105,1.068q55.106-28.383,110.217-56.758a4.074,4.074,0,0,0,2.105-3.239V240.328C755.374,252.975,745.734,264.912,733.655,272.956Z",
    transform: "translate(-641.269 -198.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M757.951,286.894q-53.5,27.553-107,55.1,0-35.739,0-71.477,53.5-27.559,107-55.1Z",
    transform: "translate(-640.379 -206.526)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPcGroup);
export default __webpack_public_path__ + "static/media/pcGroup.70cb350a6ad6e206c014e669d91c63aa.svg";
export { ForwardRef as ReactComponent };